<template>
  <div class="section">
    <div class="container">
      <div class="pt-lg-5 pb-lg-3 text-center">
        <b>
          <div
            class="display-6 fw-bolder mb-5 d-flex align-items-center justify-content-center colored"
          >
            Let's Work Together
          </div>
        </b>
        <p class="fs-18px mb-5 text-align-center">
          Womia provides the tools for distributing and annotating your own Data Catalog.<br> You can focus on what makes your Data Catalog unique
        </p>
        <div
          class="sparator"
          style=" border-bottom: 1px solid rgba(0, 0, 0, 0.2); margin: 0 280px 35px;"
        ></div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="row gx-lg-5 mb-5">
            <div class="col-lg-6 mb-5 mb-lg-0 trait">
              <a
                href="/beta/auth"
                v-if="!isAuthenticated"
                class="btn w-100 btn-primary get-started rounded-2 fw-bold fs-16px py-3 mb-5"
                >Distribute Your Data Catalog  ?</a
              >
              <a
                href="/beta/developer/dashboard"
                v-else="isAuthenticated"
                class="btn w-100 btn-primary get-started rounded-2 fw-bold fs-16px py-3 mb-5"
                >Distribute Your Data Catalog  ?</a
              >
            </div>

            <div class="col-lg-6 trait">
              <a
                href="/beta/contact-us"
                class="btn btn-lg d-block w-100 btn-default rounded-2 fw-bold fs-16px py-3 mb-5"
                >Annotate your Data Catalog ?</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from "vuex";

export default {
  name: "FooterBuildYourApp",
  computed: {
    ...Vuex.mapGetters(["isAuthenticated"])
  }
};
</script>
<style scoped>
.section {
  background: url("/beta/static/logo-shape.svg") no-repeat;
  background-size: contain;
}

@media (min-width: 2600px) {
  .section {
    background-position-x: right;
  }
}

@media (max-width: 2600px) {
  .section {
    background-position-x: 150%;
  }
}

@media (max-width: 1960px) {
  .section {
    background-position-x: 180%;
  }
}

@media (max-width: 1780px) {
  .section {
    background-position-x: 200%;
  }
}

@media (max-width: 1720px) {
  .section {
    background-position-x: 250%;
  }
}

@media (max-width: 1607px) {
  .section {
    background-position-x: 300%;
  }
}

@media (max-width: 1540px) {
  .section {
    background-position-x: 350%;
  }
}

@media (max-width: 1500px) {
  .section {
    background-position-x: 400%;
  }
}

@media (max-width: 1460px) {
  .section {
    background-position-x: 500%;
  }
}

.colored {
  background: linear-gradient(to right, #E21919, #E95913);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.btn-primary get-started  {
  background: #E21919!important;
  color: var(--bs-app-theme-color)!important;
  border-color: transparent!important;
}
.btn-primary get-started :hover{
  background: #E95913!important;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterBuildYourApp.vue